import { getEnumTranslationMap } from '../utils';

export enum ConditionUnit {
    Liter = 'litre',
    Piece = 'piece',
    Kilogram = 'kg',
}

export const conditionUnitTranslationMap = getEnumTranslationMap(ConditionUnit);

const translationObject: { [Key in ConditionUnit]: string } = {
    [ConditionUnit.Kilogram]: 'app.enum.kg',
    [ConditionUnit.Liter]: 'app.enum.litre',
    [ConditionUnit.Piece]: 'app.enum.piece',
};

export const getUnitTranslationId = (unit?: ConditionUnit): string => {
    return (unit && translationObject[unit]) || translationObject[ConditionUnit.Piece];
};
